import { useState } from "react";
import { useAuth } from "../contexto/AuthContext";
import LoginForm from "../componentes/LoginForm";
import { Alert } from "@mui/material";
import logo from "../assets/logo.png"; // 📌 Reemplaza con tu imagen
const Login = () => {
  const { login } = useAuth();
  const [errorMessage, setErrorMessage] = useState("");

  const handleLogin = async (email, password) => {
    try {
      await login(email, password);
    } catch (error) {
      setErrorMessage("Error al iniciar sesión. Verifica tus credenciales.");
    }
  };

  return (
    <div>
      {errorMessage && <Alert severity="error">{errorMessage}</Alert>}
      <LoginForm
        onLogin={handleLogin}
        onError={setErrorMessage}
        imageSrc={logo}
        title="Accede a tu área de revendedor"
      />
    </div>
  );
};

export default Login;
